import { Skeleton as MuiSkeleton, SkeletonProps } from '@mui/material';
import { useThemeTokens } from '../../../providers/themeTokenProvider';

export const Skeleton = (props: SkeletonProps) => {
  const { sys } = useThemeTokens();

  return (<MuiSkeleton sx={{ borderRadius: props.variant === 'rectangular' ? sys.borderRadius.xl : undefined, ...props.sx }} {...props} />);
};
